(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const topbarRotators = document.querySelectorAll('[data-topbar-rotator]');
    topbarRotators.forEach((rotator) => {
      const messages = Array.from(rotator.querySelectorAll('[data-topbar-message]'));
      if (messages.length < 2) return;

      const interval = Math.max(
        1500,
        Number.parseInt(rotator.dataset.topbarInterval || '4500', 10) || 4500,
      );
      const pauseOnHover = rotator.dataset.topbarPauseOnHover !== 'false';
      const transition = rotator.dataset.topbarTransition || 'slide';
      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches;

      let currentIndex = Math.max(
        0,
        messages.findIndex((message) => !message.classList.contains('hidden')),
      );
      if (currentIndex < 0) currentIndex = 0;

      const setActiveMessage = (nextIndex) => {
        if (
          nextIndex === currentIndex ||
          nextIndex < 0 ||
          nextIndex >= messages.length
        ) {
          return;
        }

        const previous = messages[currentIndex];
        const next = messages[nextIndex];

        if (previous) {
          previous.classList.add('hidden');
          previous.setAttribute('aria-hidden', 'true');
        }

        next.classList.remove('hidden');
        next.setAttribute('aria-hidden', 'false');

        if (!reducedMotion && typeof next.animate === 'function') {
          let keyframes = [{ opacity: 0 }, { opacity: 1 }];

          if (transition === 'slide') {
            keyframes = [
              { opacity: 0, transform: 'translateY(4px)' },
              { opacity: 1, transform: 'translateY(0)' },
            ];
          } else if (transition === 'marquee_soft') {
            keyframes = [
              { opacity: 0, transform: 'translateX(10px)' },
              { opacity: 1, transform: 'translateX(0)' },
            ];
          }

          next.animate(keyframes, {
            duration: transition === 'marquee_soft' ? 360 : 260,
            easing: 'ease-out',
          });
        }

        currentIndex = nextIndex;
      };

      messages.forEach((message, index) => {
        const isActive = index === currentIndex;
        message.classList.toggle('hidden', !isActive);
        message.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (reducedMotion) return;

      let timerId = null;
      let isPaused = false;

      const start = () => {
        if (timerId || isPaused) return;
        timerId = window.setInterval(() => {
          setActiveMessage((currentIndex + 1) % messages.length);
        }, interval);
      };

      const stop = () => {
        if (!timerId) return;
        window.clearInterval(timerId);
        timerId = null;
      };

      if (pauseOnHover) {
        rotator.addEventListener('mouseenter', () => {
          isPaused = true;
          stop();
        });
        rotator.addEventListener('mouseleave', () => {
          isPaused = false;
          start();
        });
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
          return;
        }
        if (!isPaused) start();
      });

      start();
    });
  });
})();
